import type { FwPakkeImageDocument, ICommonAppData } from "@/lib/types/sanity";
import imageUrlBuilder from "@sanity/image-url";
import type { ImageUrlBuilder } from "@sanity/image-url/lib/types/builder";
import type { SanityImageSource } from "@sanity/image-url/lib/types/types";
import type { Image } from "@sanity/types";

export function urlFor(source: (Image | FwPakkeImageDocument), appData: ICommonAppData): ImageUrlBuilder {
    const img = source._type === "image" ? source : source.image;
    const builder = imageUrlBuilder({ projectId: appData.sanityProjectId, dataset: appData.sanityProjectDataset });;
    return builder.image(img as SanityImageSource);
}

export function urlForAsset(source: string, isFilmweb: boolean, appData: ICommonAppData): ImageUrlBuilder {
    let builder = imageUrlBuilder({ projectId: appData.sanityProjectId, dataset: appData.sanityProjectDataset });;
    if (isFilmweb) {
        builder = builder.projectId(appData.sanityFilmwebProjectId).dataset(appData.sanityFilmwebDataset);
    }
    return builder.image(source);
}
